import {CmCollection} from "../../../../packages/graphql-layer/src";
import C086DonationCardTeaserContainer from "../../content/C086DonationCardCollection/C086DonationCardTeaserContainer";
import CCOComment from "../../fundamentals/CCOComment";
import C003Download from "../../content/C003Download/C003Download";
import CCOContainer from "../../fundamentals/CCOContainer";
import C999E2ETest from "../../content/C999E2ETest/C999E2ETest";
import C000DefaultCollection from "../../content/C000Default/C000DefaultCollection";
import React from "react";
import C078ViewTypeImageText from "../../content/C078ViewTypeImageText/C078ViewTypeImageText";
import C069ContentTag from "../../content/C069ContentTag/C069ContentTag";
import dynamic from "next/dynamic";
import C075Hero from "../../content/C075Hero/C075Hero";
import C014StageCarousel from "../../content/C014StageCarousel/C014StageCarousel";

interface Props {
    item: any,
    CAEGlobalSettings: any,
    richTextItemId?: string,
}

const C001Accordion = dynamic(() => import('../../content/C001Accordion/C001Accordion'), {
    ssr: false
})
const C004Tabs = dynamic(() => import('../../content/C004Tabs/C004Tabs'), {
    ssr: false
})
const C006DonationLine = dynamic(() => import('../../content/C006DonationLine/C006DonationLine'), {
    ssr: false
})
const C009Storytelling = dynamic(() => import('../../content/C009Storytelling/C009Storytelling'), {
    ssr: false
})
const C010Facts = dynamic(() => import('../../content/C010Facts/C010Facts'), {
    ssr: false
})
const C011Counter = dynamic(() => import('../../content/C011Counter/C011Counter'), {
    ssr: false
})
const C013FAQ = dynamic(() => import('../../content/C013FAQ/C013FAQ'), {
    ssr: false
})
const C079ViewTypeVideo = dynamic(() => import('../../content/C079ViewTypeVideo/C079ViewTypeVideo'), {
    ssr: false
})
const C016GlobalFilter = dynamic(() => import('../../content/C016GlobalFilter/C016GlobalFilter'), {
    ssr: false
})
const C008ImageGallery = dynamic(() => import('../../content/C008ImageGallery/C008ImageGallery'), {
    ssr: false
})
const C068TeaserMasonry = dynamic(() => import('../../content/C068TeaserMasonry/C068TeaserMasonry'), {
    ssr: false
})
const C015QuoteCarousel = dynamic(() => import('../../content/C015QuoteCarousel/C015QuoteCarousel'), {
    ssr: false
})
const C020TeaserCarousel = dynamic(() => import('../../content/C020TeaserCarousel/C020TeaserCarousel'), {
    ssr: false
})
const C021KachelTeaser = dynamic(() => import('../../content/C021KachelTeaser/C021KachelTeaser'), {
    ssr: false
})

function CollectionViewType(props: Props) {
    const item = props.item;
    const cmCollection = item as CmCollection;
    switch (item.viewtype) {
        // Hier können weitere viewtypes hinzugefügt werden
        case 'c001_accordion':
        case 'accordion': {
            return <CCOComment text='REACT=cmCollection.C001Accordion,CM=accordion'>
                <C001Accordion cmCollection={cmCollection} layoutSettings={item.layoutSettings}/>
            </CCOComment>
        }
        case 'c003_download':
        case 'download': {
            return <CCOComment text='REACT=cmCollection.C003Download,CM=download'>
                <C003Download cmCollection={cmCollection} layoutSettings={item.layoutSettings}/>
            </CCOComment>
        }
        case 'c004_tabs':
        case 'tabs': {
            return <CCOComment text='REACT=cmCollection.C004Tabs,CM=tabs'>
                <C004Tabs cmCollection={cmCollection} layoutSettings={item.layoutSettings}/>
            </CCOComment>
        }
        case 'c006_donation_line':
        case 'donation-line': {
            return <CCOComment text='REACT=cmCollection.C006DonationLine,CM=donation-line'>
                <C006DonationLine cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c009_storytelling':
        case 'storytelling': {
            return <CCOComment text='REACT=cmCollection.C009Storytelling,CM=storytelling'>
                <C009Storytelling cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c010_facts':
        case 'facts': {
            return <CCOComment text='REACT=cmCollection.C010Facts,CM=facts'>
                <C010Facts cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c011_counter':
        case 'globalfacts': {
            return <CCOComment text='REACT=cmCollection.C011Counter,CM=globalfacts'>
                <C011Counter cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c013_faq':
        case 'faq': {
            return <CCOComment text='REACT=cmCollection.C013FAQ,CM=faq'>
                <C013FAQ cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c014_stage_carousel':
        case 'stagecarousel': {
            return <CCOComment text='REACT=cmCollection.C014StageCarousel,CM=stagecarousel'>
                <C014StageCarousel cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c015_quote_carousel':
        case 'quotecarousel': {
            return <CCOComment text='REACT=cmCollection.C015QuoteCarousel,CM=quotecarousel'>
                <C015QuoteCarousel cmCollection={cmCollection} CAEGlobalSettings={props.CAEGlobalSettings}/>
            </CCOComment>
        }
        case 'c020_teaser_carousel':
        case 'adaptiveImageText': {
            return <CCOComment text='REACT=cmCollection.C020TeaserCarousel,CM=adaptiveImageText'>
                <C020TeaserCarousel cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c020_teaser_carousel_with_products':
        case 'donationProducts': {
            return <CCOComment text='REACT=cmCollection.C020TeaserCarousel,CM=donationProducts'>
                <C020TeaserCarousel cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c086_donation_card_collection': {
            return <CCOComment text='REACT=cmCollection.C086DonationCardCollection,CM=donationCards'>
                <C086DonationCardTeaserContainer cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c021_kachel_teaser':
        case 'adaptiveCrosslink': {
            return <CCOComment text='REACT=cmCollection.C021KachelTeaser,CM=adaptiveCrosslink'>
                <C021KachelTeaser cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c068_teaser_masonry':
        case 'teaserModule': {
            return <CCOComment text='REACT=cmCollection.C068TeaserMasonry,CM=teaserModule'>
                <C068TeaserMasonry cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c075_hero': {
            return <CCOComment text='REACT=cmCollection.C075Hero,CM=c075_hero'>
                <C075Hero cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c021_kachel_teaser_with_special_topics':
        case 'specialTopicModule': {
            return <CCOComment text='REACT=cmCollection.C021KachelTeaser,CM=specialTopicModule'>
                <CCOContainer width={"full"}>
                    <C021KachelTeaser cmCollection={cmCollection} useSquareImage={true}/>
                </CCOContainer>
            </CCOComment>
        }
        case 'c008_image_gallery':
        case 'gallery': {
            return <CCOComment text='REACT=cmCollection.C008ImageGallery,CM=gallery'>
                <C008ImageGallery gallery={cmCollection}
                                  isRichText={props.richTextItemId !== undefined}/>
            </CCOComment>
        }
        case 'c016_global_filter':
        case 'globalFilter': {
            return <CCOComment text='REACT=cmCollection.C016GlobalFilter,CM=globalFilter'>
                <C016GlobalFilter cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c078_view_type_image_text_left':
        case 'imageLeft':
        case 'c078_view_type_image_text_left_right':
        case 'imageLeftRight': {
            return <CCOComment text='REACT=cmCollection.C078ViewTypeImageText,CM=imageLeft|imageLeftRight'>
                <C078ViewTypeImageText cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c079_view_type_video':
        case 'video': {
            return <CCOComment text='REACT=cmCollection.C079ViewTypeVideo,CM=video'>
                <C079ViewTypeVideo cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'c069_content_tag':
        case 'link': {
            return <CCOComment text='REACT=cmCollection.C069ContentTag,CM=link'>
                <C069ContentTag cmCollection={cmCollection}/>
            </CCOComment>
        }
        case 'e2etest': {
            return <C999E2ETest cmCollection={cmCollection}/>
        }
        default: {
            return <CCOComment text='cmCollection.C000DefaultCollection'>
                <C000DefaultCollection cmCollection={cmCollection}/>
            </CCOComment>
        }
    }
}

export default CollectionViewType